// extracted by mini-css-extract-plugin
export default {"container":"ProjectsListTable_container__K1Tvn"};